import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const WaveLayerLineWidthListItem = memo(({
    waveLayerLineWidth,
    index,
    updateWaveLayer,
    maxLineWidth
}) => {
    const handleWidthChange = useCallback((value) => {
        previewHistoryBatch.start();
        updateWaveLayer(index, { lineWidth: value });
    }, [updateWaveLayer, index]);

    return (
        <SliderListItem
            title='Outline Width'
            value={waveLayerLineWidth}
            displayMultiplier={1}
            min={0}
            max={maxLineWidth}
            step={1}
            onValueChange={handleWidthChange}
        />
    );
});

const mapStateToProps = (state, { index }) => ({
    waveLayerLineWidth: state.createPreview.present.videoSettings.visualizer.waveCircles[index].lineWidth,
    maxLineWidth: state.create.maxValues.maxLineWidth
});

const mapDispatchToProps = {
    updateWaveLayer: (index, properties) => createActions.updateWaveLayer(index, properties)
};

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerLineWidthListItem);